import { render, staticRenderFns } from "./iam-view-page-admin.vue?vue&type=template&id=331a9d16&"
import script from "./iam-view-page-admin.vue?vue&type=script&lang=js&"
export * from "./iam-view-page-admin.vue?vue&type=script&lang=js&"
import style0 from "./iam-view-page-admin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn,QCard,QField} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBreadcrumbs,QIcon,QBreadcrumbsEl,QBtn,QCard,QField})
